
import React from 'react';

class Header extends React.Component {
  render(){
    
    return (
      <div className="header-body">
      
      <div className="navbar navbar-fixed-top">
          <div>
        
         <div className="header-avatar pull-right">
          <img src="https://www.w3schools.com/howto/img_avatar.png" alt="User Avatar"/>
          </div>
          </div>
       </div>
     </div>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/app/common/header/Header.js